module.exports = __webpack_public_path__ + "img/8.2d7b3045.png";